import React, { useState } from 'react'

import 'primeflex/primeflex.css'
import 'primeicons/primeicons.css'
import 'primereact/resources/primereact.css'
import 'primereact/resources/themes/lara-light-indigo/theme.css'
import { Button } from 'primereact/button'
import { Toolbar } from 'primereact/toolbar'
import { Modal } from 'antd'

import { getMessage } from '../../../util/IntlMessages'
import CreateGroup from './CreateGroup'

const Header = ({ customerId, updateGroupsList }) => {
  const [modalGroupVisible, setModalGroupVisible] = useState(false)
  return (
    <Toolbar
      left={
        <React.Fragment>
          <div>
            <h2>
              <b>Grupos de Alternativos</b>
            </h2>
          </div>
        </React.Fragment>
      }
      right={
        <React.Fragment>
          <Button
            icon="pi pi-plus"
            className="btn btn-info"
            style={{ display: 'flex', justifyContent: 'center', height: 45, width: 45, lineHeight: 0.5 }}
            onClick={() => setModalGroupVisible(true)}
          />
          <Modal
            title={getMessage('createGroup')}
            footer={null}
            onCancel={() => {
              setModalGroupVisible(!modalGroupVisible)
            }}
            width="30%"
            visible={modalGroupVisible}
          >
            <CreateGroup
              setModalGroupVisible={setModalGroupVisible}
              customerId={customerId}
              updateGroupsList={updateGroupsList}
            />
          </Modal>
        </React.Fragment>
      }
    />
  )
}

export default Header
